import { Link } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import { FaSync } from 'react-icons/fa'; // Update icon
import './ManageInventory.css'; // Reusing same styles

const ManageInventory = () => {
  return (
    <div className="layout"> {/* Flex container */}
      <Sidebar /> {/* Sidebar on the left */}

      <div className="main-content"> 
        <div className="card">
          <h1 className="title">📦 Inventory Management</h1>

          <div className="button-grid">
            <Link to="/AddInventoryManually" className="btn">
              ➕ Add Inventory Manually
            </Link>

            <Link to="/UpdateInventoryManually" className="btn">
              ✏️ Update Inventory Manually
            </Link>

            <Link to="/UploadInventoryCSV" className="btn">
              📤 Upload CSV Inventory
            </Link>

            <Link to="/UpdateInventoryCSV" className="btn">
              <FaSync style={{ marginRight: '6px' }} />
              Update CSV Inventory
            </Link>

            <Link to="/InventoryItem" className="btn">
              📋 List Inventory
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageInventory;
